import { FC, useEffect, useState } from "react";
import SemesterSelect from "../../common/SemesterSelect";
import LevelSelect from "../../common/LevelSelect";
import MultiCampusModal from "../regular-test/modals/MultiCampusModal";
import { ArticleContents } from "../../../pages/statistics/articles";
import { useTranslation } from "react-i18next";
import Button from "../../Button";
import SelectCampus from "../../SelectCampus";
import { DatePicker } from "antd";
import moment from "moment";
import { useSelector } from "react-redux";
import { RootState } from "../../../store/rootReducer";
import useNotification from "../../../hooks/useNotification";
import SelectCampusMultiChoice from "../../SelectCampusMultiChoice";

interface IProps {
  content: ArticleContents;
  getArticleData: (params?: any) => void;
};

const StatisticsArticleSearchForm: FC<IProps> = ({
  content,
  getArticleData,
}) => {
  const { t } = useTranslation();
  const { infoNotification } = useNotification();
  const { auth, currentCampus } = useSelector((state: RootState) => state.auth);
  const { serverDate } = useSelector((state: RootState) => state.serverDate);

  const [semesterCode, setSemesterCode] = useState<number>();
  const [courseCode, setCourseCode] = useState<string>();
  const [srtDate, setSrtDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [isFirstRun, setIsFirstRun] = useState(true);
  const [multiCampusVisible, setMultiCampusVisible] = useState(false);
  const [campusCodes, setCampusCodes] = useState<string[]>([]);

  useEffect(() => {
    setCourseCode("");
  }, [])

  useEffect(() => {
    if (serverDate) {
      //setSrtDate(moment(serverDate).subtract(1, 'months').format('YYYYMMDD'));
      setSrtDate(moment(serverDate).format('YYYYMM01'));
      setEndDate(moment(serverDate).format('YYYYMMDD'));
    }
  }, [serverDate]);

  useEffect(() => {
    if (isFirstRun) {
      setIsFirstRun(false);
      return;
    }
    if (content === ArticleContents.List && !courseCode) {
      setCourseCode(undefined);
    }
    onSearch();
  }, [content]);

  const onSearch = () => {
    if (!semesterCode) {
      return infoNotification(t('statistics.dttt.message1'));
    }
    if (content === ArticleContents.List && !courseCode) {
      return infoNotification(t('statistics.articles.1'));
    }
    if (!srtDate || !endDate) {
      return infoNotification(t('statistics.dttt.message2'));
    }

    const params: any = {
      semesterCode,
      courseCode,
      campusCode: content === ArticleContents.Summary
        ? auth.hqYn === 'Y'
          ? campusCodes
          : (campusCodes.length ? campusCodes : auth.campus)
        : currentCampus,
      srtDate,
      endDate,
    };

    getArticleData(params);
  };

  return (
    <>
    <div className="common-search">
      <div className="search-area">
        <ul className="search-bx">
          <li>
            <label>{t('common.menu.campus')}</label> {/* 캠퍼스 */}
            {
              content === ArticleContents.Summary
                ? (
                  <>
                    <SelectCampusMultiChoice
                      placeholder={t('statistics.eLearning.title2')}
                      onChange={setCampusCodes}
                      value={campusCodes}
                    />
                    <label>
                      ({
                        campusCodes.length
                          ? `${t('statistics.attendance.text2')}${campusCodes.length}${t('statistics.attendance.text1')}`
                          : t('common.text.all')
                      })
                    </label>
                  </>
                  )
                : <div><SelectCampus /></div>
            }
          </li>
          <li>
            <label>{t('class.class.placeholder4')}</label> {/* 학기 */}
            <div>
              <SemesterSelect
                semesterCode={semesterCode}
                setSemesterCode={setSemesterCode}
                semesterType={'RG'}
              />
            </div>
          </li>
          <li>
            <label>{t('student.student.column26')}</label>  {/* 레벨 */}
            <div>
              <LevelSelect
                courseCode={courseCode}
                setCourseCode={setCourseCode}
                includeAll={content === ArticleContents.Summary}
                eduStepCode="MD"
              />
            </div>
          </li>
          <li>
            <label>{t('sms.list.column1')}</label> {/* 기간*/}
            <div className="date-picker__area">
              <DatePicker
                value={srtDate ? moment(srtDate) : undefined}
                onChange={e => {
                  if (e === null) setSrtDate('');
                  else setSrtDate(moment(e).format('YYYYMMDD'))
                }}
                format={['YYYY-MM-DD', 'YYYYMMDD']}
              />
            </div>
            ~
            <div className="date-picker__area">
              <DatePicker
                value={endDate ? moment(endDate) : undefined}
                onChange={e => {
                  if (e === null) setEndDate('');
                  else setEndDate(moment(e).format('YYYYMMDD'))
                }}
                format={['YYYY-MM-DD', 'YYYYMMDD']}
              />
            </div>
            <div className="comm-btn__area">
              <Button
                className="btn-basic small black"
                onClick={onSearch}
                text={t('common.button.search')}
              />
            </div>
          </li>
        </ul>
      </div>
    </div>	
    <div className="flex flex-justify-center">
      {multiCampusVisible &&
        <MultiCampusModal
          visible={multiCampusVisible}
          setVisible={setMultiCampusVisible}
          campusCodes={campusCodes}
          setCampusCodes={setCampusCodes}
        />
      }
    </div>
    </>
  );
};

export default StatisticsArticleSearchForm;